export const getFormattedDateInfo = (date, selectedHour, settings) => {
	if (!date) return '';
	// Get day names from settings or use default Romanian names
	const dayNames = settings?.dayNames?.split(',') || [
		'Luni',
		'Marți',
		'Miercuri',
		'Joi',
		'Vineri',
		'Sâmbătă',
		'Duminică',
	];

	// Get day of week (0 = Sunday, 1 = Monday, etc.)
	const dayOfWeek = date.getDay();
	// Convert to Monday = 0 format
	const mondayBasedDay = (dayOfWeek + 6) % 7;

	// Ensure we have a valid day name
	const dayName = dayNames[mondayBasedDay] || dayNames[dayOfWeek] || '';

	// Format date as DD-MM-YYYY
	const day = date.getDate().toString().padStart(2, '0');
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const year = date.getFullYear();
	const formattedDate = `${day}-${month}-${year}`;

	return `${dayName} ${formattedDate}${selectedHour ? `, ${selectedHour}` : ''}`;
};

export const returnIntervalAvailable = async (timeValue, gadgetApi, maxPerHour, cartToken) => {
	const fiveMinutesAgo = new Date(Date.now() - 1000 * 60 * 5);
	// Find all reservations for this time slot
	const allIntervals = await gadgetApi.selectedInterval.findMany({
		filter: {
			AND: [
				{
					value: {
						equals: timeValue,
					},
					deliveryMethod: {
						equals: 'delivery',
					},
				},
			],
		},
		select: {
			cartToken: true,
			updatedAt: true,
			orderConfirmed: true,
		},
	});

	// console.log('allIntervals', allIntervals);

	// Count blocking reservations:
	// A reservation blocks if:
	// 1. It's confirmed (orderConfirmed = true), OR
	// 2. It's active (updatedAt < 5 minutes ago) AND it's not our own active reservation
	let blockingCount = 0;

	for (const interval of allIntervals) {
		const updatedAt = new Date(interval.updatedAt);
		const isActive = updatedAt > fiveMinutesAgo;
		const isOurs = interval.cartToken === cartToken;

		// Confirmed orders always block
		if (interval.orderConfirmed) {
			blockingCount++;
			continue;
		}

		// Active reservations block, except our own active reservation
		if (isActive && !isOurs) {
			blockingCount++;
		}
	}

	// console.log('allIntervals', allIntervals);

	// console.log('blockingCount', blockingCount);
	// console.log('maxPerHour', maxPerHour);

	// Available if blocking count is less than maxPerHour
	return blockingCount < maxPerHour;
};

export const validateCUI = (v, settings) => {
	const response = {
		valid: true,
		message: settings.cuiValid,
	};

	if (typeof v !== 'string') {
		response.valid = false;
		response.message = settings.cuiInvalid;

		return response;
	}

	let cif = v.toUpperCase();

	// remove RO from cif:
	cif = cif.indexOf('RO') > -1 ? cif.substring(2) : cif;
	// remove spaces:
	cif = cif.replace(/\s/g, '');

	// validate character length:
	if (cif.length < 2 || cif.length > 10) {
		response.valid = false;
		response.message = settings.cuiLengthError;

		return response;
	}

	// validate that so far the resulting CIF looks like an integer value:
	if (Number.isNaN(parseInt(cif))) {
		response.valid = false;
		response.message = settings.cuiIntegerError;

		return response;
	}

	// begin testing:
	const testKey = '753217532';
	const controlNumber = parseInt(cif.substring(cif.length - 1));

	// remove control number:
	cif = cif.substring(0, cif.length - 1);
	// pad left with zeros to reach testKey length:

	while (cif.length !== testKey.length) {
		cif = '0' + cif;
	}

	let sum = 0;
	let i = cif.length;

	while (i--) {
		sum = sum + parseInt(cif.charAt(i)) * parseInt(testKey.charAt(i));
	}

	let calculatedControlNumber = (sum * 10) % 11;

	if (calculatedControlNumber === 10) {
		calculatedControlNumber = 0;
	}

	response.valid = controlNumber === calculatedControlNumber;
	response.message = controlNumber === calculatedControlNumber ? settings.cuiValid : settings.cuiInvalid;

	return response;
};
